import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import * as actions from 'Global/Stores/groups'
import * as layoutActions from 'Global/Stores/layout'
import * as selectors from './selectors'
import { groupCreateModalShow } from 'Global/Stores/modals'

const module = 'groups'

const limitToggle = layoutActions.makeLimitToggle(module)
const pageSet = layoutActions.makePageSet(module)
const sortBySet = layoutActions.makeSortBySet(module)
const sortOrderToggle = layoutActions.makeSortOrderToggle(module)

export default function(WrappedComponent) {
  const Enhancer = props => <WrappedComponent {...props} />

  const mapStateToProps = (state, ownProps) => ({
    createdGroup: selectors.createdGroup(state),
    groups: selectors.slicedFilteredGroups(state),
    groupsDone: selectors.groupsDone(state),
    groupsError: selectors.groupsError(state),
    groupsPending: selectors.groupsPending(state),
    limit: selectors.limit(state),
    pagination: selectors.calculatePagination(state),
    sortBy: selectors.sortBy(state),
    sortOrder: selectors.sortOrder(state),
    user: selectors.user(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    getGroups: () => dispatch(actions.groupsGet()),
    redirectToNewGroup: id => dispatch(push(`/groups/${id}`)),
    setPage: page => dispatch(pageSet(page)),
    setSortBy: column => dispatch(sortBySet(column)),
    showCreateGroupModal: () => dispatch(groupCreateModalShow()),
    toggleLimit: () => dispatch(limitToggle()),
    toggleSortOrder: order => dispatch(sortOrderToggle()),
  })

  Enhancer.displayName = 'GroupsModuleEnhancer'

  Enhancer.propTypes = {
    createdGroup: PropTypes.number,
    getGroups: PropTypes.func.isRequired,
    groups: PropTypes.array.isRequired,
    groupsDone: PropTypes.bool.isRequired,
    groupsError: PropTypes.bool.isRequired,
    groupsPending: PropTypes.bool.isRequired,
    redirectToNewGroup: PropTypes.func.isRequired,
    setPage: PropTypes.func.isRequired,
    setSortBy: PropTypes.func.isRequired,
    showCreateGroupModal: PropTypes.func.isRequired,
    toggleLimit: PropTypes.func.isRequired,
    toggleSortOrder: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Enhancer)
}
